import React, {useEffect} from 'react';
import {Container} from 'react-bootstrap';
import { SansabotsCountdown } from '../components/SansabotsCountdown';


export const SansabotsFighterEdition = () => {

    useEffect(() => {
        document.title = "Pronto: Sansabots - Fighter Edition 2K23";
    });

    return (
        <Container className="fablab-page" fluid>                                
            <SansabotsCountdown/>
        </Container>
    )
}
